// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"o2-z"};